import { api } from '@services';

interface IRemoveTaskProducts {
  taskId: string;
  productsIds: string[];
}

const removeTaskProducts = async ({
  taskId,
  productsIds,
}: IRemoveTaskProducts): Promise<void> => {
  await api.post(`/tasks/${taskId}/products-remove`, { productsIds });
};

export { removeTaskProducts };
